const getStorageKey = (userId: string, skillCode: string) => `pp-progress:${userId}:${skillCode}`;

export const saveProgress = (userId: string, skillCode: string, reference: string) => {
  localStorage.setItem(getStorageKey(userId, skillCode), reference);
};

export const clearProgress = (userId: string, skillCode: string) => {
  localStorage.removeItem(getStorageKey(userId, skillCode));
};

export const getProgress = (userId: string, skillCode: string) => {
  return localStorage.getItem(getStorageKey(userId, skillCode));
};
